import React, { CSSProperties, FC, useEffect } from 'react';
import { useQuery } from '@apollo/client/react';
import { LayoutTree } from '../../../DynamicLayout';
import {
  NarvarEventComponents,
  NarvarEventTypes,
  useAnalyticsPost,
} from '../../../../../hooks/Analytics';
import { usePageContext } from '../../../../../hooks/PageContext/usePageContext';
import ResizableMap from './ResizableMap';
import maptilerQuery from './graphql';
import { MaptilerQuery } from '../../../../../../../__generated__/loma';

const { FeatureLayout } = LayoutTree;

export interface Coordinates {
  lng?: number | null;
  lat?: number | null;
}

export interface MaptilerMapProps {
  coordinates?: Coordinates | null;
  layout?: LayoutTree.FeatureLayout;
  featureName?: string;
  s?: CSSProperties;
}

const MaptilerMap: FC<MaptilerMapProps> = ({
  coordinates,
  featureName,
  layout = FeatureLayout.PORTRAIT,
  s = {
    height: '20rem',
    width: '20rem',
  },
}) => {
  const { data } = useQuery<MaptilerQuery>(maptilerQuery);
  const key = (data && data.maptiler && data.maptiler.key) || '';
  const { lng, lat } = coordinates || {};
  const {
    state: { orderNumbers },
  } = usePageContext();

  const logEvent = useAnalyticsPost();

  useEffect(
    () => {
      logEvent({
        eventComponent: NarvarEventComponents.NTH_BLOCK_MAPTILER_MAP,
        eventFeature: NarvarEventComponents.NTH_BLOCK_MAPTILER_MAP,
        eventType: NarvarEventTypes.COMPONENT_RENDER,
        feature: featureName,
        orderNumber: orderNumbers && orderNumbers[0],
        pageComponent: NarvarEventComponents.NTH_BLOCK_MAPTILER_MAP,
        pageOrderNumber: orderNumbers && orderNumbers[0],
        trackLayout: layout,
      });
    },
    // TODO: Make this dependency array exhaustive
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  if (
    !(coordinates && typeof lng === 'number' && typeof lat === 'number' && key)
  )
    return null;

  return <ResizableMap coordinates={{ lat, lng }} maptilerKey={key} s={s} />;
};

export default MaptilerMap;
